export enum ReglePrefereeCommandeFournisseurEnum {
  ARTICLE_PREFEREE= 'ARTICLE_PREFEREE',
  ARTICLE_LE_MOINS_CHER = 'ARTICLE_LE_MOINS_CHER',
  FILIALE_PREFEREE = 'FILIALE_PREFEREE',
  MARCHE_ARTICLE_AVEC_ORDRE = 'MARCHE_ARTICLE_AVEC_ORDRE',
  MARCHE_ARTICLE_LE_MOINS_CHER = 'MARCHE_ARTICLE_LE_MOINS_CHER'
}
